import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./Services.css";
import outdoor from "./images/services-outdoor.jpg";
import DigitalBillboards from "./images/Digital-Billboards.jpg";
import TransitAdvertising from "./images/Transit-Advertising.jpg";
import StreetFurniture from "./images/Street-Furniture.jpg";
import DesignAndPrinting from "./images/Design-and-Printing.jpg";
import CampaignManagemen from "./images/Campaign-Managemen.jpg";
import MarketResearch from "./images/Market-Research.jpg";
import InstallationAndMaintenance from "./images/Installation-and-Maintenance.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRocket,
  faLightbulb,
  faMedal,
  faHandshake
} from "@fortawesome/free-solid-svg-icons";
export default function Services() {
  const servicesData = [
    {
      id: 1,
      title: "Outdoor Advertising",
      description:
        "Strategic placement of billboards in high-traffic areas for maximum visibility and brand impact.",
      image: outdoor,
    },
    {
      id: 2,
      title: "Digital Billboards",
      description:
        "Modern digital displays with dynamic content that can be updated remotely for timely messaging.",
      image: DigitalBillboards,
    },
    {
      id: 3,
      title: "Transit Advertising",
      description:
        "Advertising on buses, trains, and transit stations to reach commuters and travelers effectively.",
      image: TransitAdvertising,
    },
    {
      id: 4,
      title: "Street Furniture",
      description:
        "Advertising on bus shelters, kiosks, benches, and other street furniture in urban areas.",
      image: StreetFurniture,
    },
    {
      id: 5,
      title: "Design & Printing",
      description:
        "Creative design services and high-quality printing for all your advertising materials, from business cards to large format prints.",
      image: DesignAndPrinting,
    },
    {
      id: 6,
      title: "Campaign Management",
      description:
        "End-to-end management of advertising campaigns from planning and strategy to execution and performance analysis.",
      image: CampaignManagemen,
    },
    {
      id: 7,
      title: "Market Research",
      description:
        "Comprehensive market analysis and consumer insights to optimize your advertising strategy and maximize ROI.",
      image: MarketResearch,
    },
    {
      id: 8,
      title: "Installation & Maintenance",
      description:
        "Professional installation and ongoing maintenance services for all advertising structures and digital displays.",
      image: InstallationAndMaintenance,
    },
  ];
  return (
    <div className="Services ">
      <NavBar />
      {/* Hero Section */}
      {/* Hero Section */}
      <section className="services-hero">
        <div className="services-hero-content container">
          <h1>Our Premium Services</h1>
          <p>
            Comprehensive advertising solutions to elevate your brand presence
          </p>
          <div className="services-hero-stats">
            <div className="services-hero-stat">
              <FontAwesomeIcon icon={faRocket} />
              <span>360° Campaign Management</span>
            </div>
            <div className="services-hero-stat">
              <FontAwesomeIcon icon={faLightbulb} />
              <span>Creative Design Solutions</span>
            </div>
            <div className="services-hero-stat">
              <FontAwesomeIcon icon={faMedal} />
              <span>Premium Billboard Locations</span>
            </div>
            <div className="services-hero-stat">
              <FontAwesomeIcon icon={faHandshake} />
              <span>Dedicated Account Management</span>
            </div>
          </div>
        </div>
        <div className="services-hero-overlay"></div>
      </section>{" "}
      {/* Services Cards Section */}
      <div className="services-cards">
        <div className="container">
          <div className="row">
            {servicesData.map((service) => (
              <div key={service.id} className="service-card">
                <img src={service.image} alt={service.title} />
                <div className="service-title">
                  <h3>{service.title}</h3>
                </div>
                <div className="service-overlay">
                  <div className="overlay-content">
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
